import React from "react";
import { VodContentImageReport } from "../../../../../models/epg/Models";
import Card from "../../../../../components/themed/Card";

interface ImageStatsProps {
    vodImageStats: {
        values: VodContentImageReport,
        imagesTotal: number
    };
}

const ImageStats = ({ vodImageStats } : ImageStatsProps) => {
    const entries = vodImageStats ? Object.entries(vodImageStats.values) : [];

    return (
        <Card>
            <div className={`p-5 flex flex-col justify-between`}>
                <div>
                    <p className = {`font-bold text-2xl`}>Images</p>
                    <div className={`flex flex-col gap-3 py-5`}>
                        {
                            entries.map(entry => {
                                const [ key, value ] = entry;
                                return(
                                    <div key={key} className={`flex justify-between py-5 px-3 shadow-md bg-light dark:!bg-brand-800 rounded-lg`}>
                                        <p>{`${key[0].toUpperCase()}${key.substring(1)} Images`}</p>
                                        <p className={`font-bold`}>{new Intl.NumberFormat("en-US").format(value)}</p>
                                    </div>
                                );})
                        }
                    </div>
                </div>
                <div className={`py-5 flex flex-row justify-between`}>
                    <p className={`text-gray-500 font-bold text-lg`}>Total Images</p>
                    <p className={`font-bold text-gray-500 text-lg`}>{new Intl.NumberFormat("en-US").format(Math.round(vodImageStats.imagesTotal))}</p>
                </div>
            </div>
        </Card>
    );
};

export default ImageStats;